import {
  SeuApiConverter,
  SeuIndustryType,
  SeuIndustryTypeApi,
} from '@seu-types';
import { neverError } from '../helpers/never.helper';

export const industryTypeConverter: SeuApiConverter<
  SeuIndustryType,
  SeuIndustryTypeApi
> = {
  fromApi: (input) => {
    switch (input) {
      case 'METAL':
        return 'metal';
      case 'GLASS':
        return 'glass';
      case 'LIGNO':
        return 'ligno';
      case 'ERCS':
        return 'ercs';
      case 'ENERGY':
        return 'energy';
      case 'PANELS':
        return 'panels';
      case 'IMI':
        return 'imi';
      default:
        throw neverError(input);
    }
  },
  toApi: (input) => {
    switch (input) {
      case 'metal':
        return 'METAL';
      case 'glass':
        return 'GLASS';
      case 'ligno':
        return 'LIGNO';
      case 'ercs':
        return 'ERCS';
      case 'energy':
        return 'ENERGY';
      case 'panels':
        return 'PANELS';
      case 'imi':
        return 'IMI';
      default:
        throw neverError(input);
    }
  },
};
